<template>
  <el-table :data="currentValue" max-height="250" :span-method="arraySpanMethod" v-loading="loading" ref="table">
		<lab-order-column slot="append" :showFields="showFields" :getFocus="getFocus" @updateFocus="updateFocus" :showCopy="showCopy"></lab-order-column>
		<el-table-column label="操作" fixed="right" v-if="isShow('操作')">
			<template slot-scope="scope">
				<slot :row="scope.row"></slot>
			</template>
		</el-table-column>
    <!-- 如果不插入一个fixed会造成列的顺序不对，所以默认会加一个2px的空白 -->
    <el-table-column label="" fixed="right" v-else width="2">
		</el-table-column>
	</el-table>
</template>
<script>
/**
 * 批次内的订单视图
 */
import labOrderColumn from 'cps/lab-order/process/form/components-with-data/lab-order-column'
import { genderFormat } from '@/utils/formUtils.js'
export default {
  name: 'lot-operate-list',
  props: {
    value: {
      type: Array,
      required: true
    },
    showFields: {
      type: Array,
      default: () => []
    },
    merge: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    getFocus: {
      type: Boolean,
      default: false
    },
    showCopy: {
      type: Boolean,
      default: false
    }
  },
  components: {
    labOrderColumn
  },
  data () {
    return {
      currentValue: this.buildData()
    }
  },
  watch: {
    'value' (val, old) {
      this.getScroll()
      if (val !== old) {
        this.currentValue = this.buildData()
      }
    }
  },
  methods: {
    genderFormat,
    // birthdayToAge,
    // formatSampleType,
    isShow (label) {
      return this.showFields.indexOf(label) > -1
    },
    buildData () {
      return this.value
    },
    updateFocus (val) {
      this.$emit('updateFocus', val)
    },
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex === 0) {
      //     if (rowIndex % 2 === 0) {
      //       return {
      //         rowspan: 2,
      //         colspan: 1
      //       };
      //     } else {
      //       return {
      //         rowspan: 0,
      //         colspan: 0
      //       };
      // 		}
      // 	}
    },
    getScroll () {
      this.$nextTick(() => {
        let table = this.$refs.table.$el.querySelector('.el-table__body-wrapper')
        table.scrollTop = table.scrollHeight
      })
    }
  }
}
</script>
